import { CoolingSystemLayout } from './CoolingSystem.layout';
import { HeatingSystemLayout } from './HeatingSystem.layout';

export class UnitLayout {
	public fields = [{ fieldName: 'unitType' }];

	public fieldsArray = [
		{
			fieldName: 'coolingSystems',
			label: 'Cooling Systems',
			fields: new CoolingSystemLayout().fields
		},
		{
			fieldName: 'heatingSystems',
			label: 'Heating Systems',
			fields: new HeatingSystemLayout().fields
		}
	];
}
